module.exports = __webpack_public_path__ + "assets/img/nh4.7550de94.jpg";